import React from 'react'
import contactimg from '../../../../../assets/images/home/contactimg.png'
import { useNavigate } from 'react-router-dom'
import { useFormik } from 'formik';


const ContactUs = () => {
    const navigate = useNavigate();

    return (
        <>
            <div className="contacthome">
                <div className="container w-75">
                    <div className="contcontbx ">
                      
                            <div className="cn-box-left">

                                <h1>
                                    Didn't find what you were looking for? <br/>
                                    We know every idea is <span className='text-danger'>unique</span>
                                    </h1>
                                <p>Please give us an opportunity to support you better</p>
                                <button onClick={()=>navigate('/contact')} className='btn btn-warning'>Contact us </button>
                            </div>
                         
                                <img src={contactimg} className='cn-box-img' alt="" />
                            
                       
                    </div>
                </div>
            </div>
        </>
    )
}

export default ContactUs
